import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 p-8 w-full" }
const _hoisted_2 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "flex flex-row justify-center items-center gap-4 w-full" }



import NewModal from "@/components/atoms/NewModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowCommentModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
  comment:{
    type:String,
    required:false,
  }
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewModal, {
    title: "Comentario",
    visible: __props.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = () => _ctx.$emit('update:visible'))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('update:visible')),
          type: "button",
          class: "flex flex-row items-center rounded-full px-4 py-2 bg-gray-400 transition text-sm shadow text-white"
        }, " Entendido ")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("textarea", {
            disabled: "",
            class: "border w-full border-gray-300 rounded-md p-2 h-48 text-sm overflow-auto",
            value: __props.comment
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})